import { getUserToken } from "../api-services/users";
import { cognitoLogout } from "./user-auth-provider";
import { sentryService } from "./sentry-service";

export const isBrowser = () => typeof window !== "undefined";

export const getCsrfToken = async () => {
  const userIndex = await getUserToken();
  const { csrfToken } = userIndex;
  if (isBrowser()) {
    window.localStorage.setItem("token", csrfToken);
  }
  return csrfToken;
};

export const logout = async (callback = undefined) => {
  await cognitoLogout().finally(async () => {
    localStorage.clear();
    sentryService.removeUser();
    sentryService.removeTag("company_domain");
    if (typeof callback === "function") {
      await callback();
      return;
    }
    window.location.href = "/login";
  });
};
